import { ComponentStatus, HeartBeatStatusIndicators } from '@Types';
import { DateTime } from 'luxon';
import { getIsComponentInGoodState } from './getIsComponentInGoodState';

// High level translation of the shadow to visible color:
// green
// Component reports status=good AND a timestamp < 6 minutes ago
// yellow
// Component reports status=good AND a timestamps < 11 minutes ago
// red
// Component reports status other than good, or a timestamp > 11 minutes ago
export const getComponentStatus = (
	timestamp: number,
	state: ComponentStatus,
	componentName: string,
): HeartBeatStatusIndicators => {
	const greenTimestampTime = DateTime.now().minus({ minutes: 6 }); // 6 minutes ago
	const yellowTimestampTime = DateTime.now().minus({ minutes: 11 }); // 11 minutes ago
	const luxonTimestamp = DateTime.fromMillis(timestamp * 1000);

	const isComponentInGoodState = getIsComponentInGoodState(
		componentName,
		state,
	);

	let componentStatus = HeartBeatStatusIndicators.Red;
	if (isComponentInGoodState && luxonTimestamp >= greenTimestampTime)
		componentStatus = HeartBeatStatusIndicators.Green;
	else if (isComponentInGoodState && luxonTimestamp >= yellowTimestampTime)
		componentStatus = HeartBeatStatusIndicators.Yellow;

	return componentStatus;
};
